// extracted by mini-css-extract-plugin
module.exports = {"singleLine":"singleLine--22ZRw","multiLine":"multiLine--3UU6-"};